<template>
  <div class="productMobile">
    <img src="https://cdn.youjiajk.com/productImg1.png"  style="width: 100%;height:7.85rem;" />
    <img src="https://cdn.youjiajk.com/productImg2.png" style="width: 100%;height: 8.18rem;" />
    <img src="https://cdn.youjiajk.com/productImg3.png" style="width: 100%;height:15.26rem;" alt="">
    <!-- <img src="https://cdn.youjiajk.com/productImg4.png" style="width: 100%;height:7.95rem;" alt=""> -->
    <!-- <img src="https://cdn.youjiajk.com/productImg5.png" style="width: 100%;height:7.84rem;" alt=""> -->
    <img src="https://cdn.youjiajk.com/productImg5Gray.png" style="width: 100%;height: 7.84rem;" alt="">
    <!-- <img src="https://cdn.youjiajk.com/productImg6.png" style="width: 100%;height:7.97rem;" alt=""> -->
    <img src="https://cdn.youjiajk.com/productImg6White.png" style="width: 100%;height: 7.97rem;" alt="">

  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    methods:{
    }
    
  }
</script>

<style lang="less" scoped>
  .backgroundGray {
    background: #F7FAFF;
  }

  .productMobile{
    display: flex;
    flex-direction: column;
  }

</style>


// WEBPACK FOOTER //
// src/views/mobile/productMobile.vue